module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('client-list', {
    staticClass: "box",
    on: {
      "selected": _vm.selected,
      "deselected": _vm.deselected
    }
  }), (_vm.seleccionado) ? _c('client-contact-list', {
    staticClass: "box",
    attrs: {
      "cliente": _vm.clienteSeleccionado
    }
  }) : _vm._e(), (_vm.seleccionado) ? _c('client-equipo-list', {
    staticClass: "box",
    attrs: {
      "cliente": _vm.clienteSeleccionado
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72e1e830","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/View_Cliente_Admin.vue
// module id = 507
// module chunks = 1